// extracted by mini-css-extract-plugin
export default {"placeholder":"OrganizationSuspended_placeholder__mAD33","placeholderWrapper":"OrganizationSuspended_placeholderWrapper__4+3HV","title":"OrganizationSuspended_title__+24-q"};